import { Box, Button, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { useState } from 'react';

const UploadedImageList = ({ uploadedFiles }) => {
   
  const [copiedId, setCopiedId] = useState(null);

  const handleCopyUrl = (url, id) => {
    navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const columns = [
    {
      field: 'image',
      headerName: 'Image',
      width: 100,
      renderCell: (params) => (
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: 1,
            overflow: 'hidden',
          }}
        >
          <img
            src={params.row.url}
            alt={params.row.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      ),
    },
    {
      field: 'details',
      headerName: 'Details',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={{ p: 1, width: '100%' }}>
            <Box sx={{display:'flex',gap:1}}>
                <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>BaseUrl</Typography>
                <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
                <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.data?.imageBaseUrl}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1}}>
                <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>Directory</Typography>
                <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
                <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.data?.imageDirectory}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1}}>
                <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>SUb Dir.</Typography>
                <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
                <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.data?.imageSubDirectory}</Typography>
            </Box>
            <Box sx={{display:'flex',gap:1}}>
                <Typography  sx={{ fontSize: '0.65rem',fontWeight:600,width:'45%'}}>filename</Typography>
                <Typography  sx={{ fontSize: '0.65rem',width:'5%' }}>:</Typography>
                <Typography  sx={{ fontSize: '0.65rem', }}>{params.row.data?.imageName}</Typography>
            </Box>
        </Box>
      )
    },
    {
      field: 'url',
      headerName: 'URL',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
          <Typography
            variant="body2"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
            }}
          >
            {params.value}
          </Typography>
          <Button
            size="small"
            onClick={() => handleCopyUrl(params.value, params.row.id)}
            sx={{ minWidth: 'auto', p: 0.5 }}
          >
            {copiedId === params.row.id ? (
              <CheckIcon sx={{ fontSize: 18, color: 'success.main' }} />
            ) : (
              <ContentCopyIcon sx={{ fontSize: 18 }} />
            )}
          </Button>
        </Box>
      ),
    },
  ];

  const rows = uploadedFiles.map((img, index) => ({
    id: index,
    name: img.name,
    url: img.url,
    data: img.data,
  }));

  return (
    <Box sx={{ height: 'auto', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disablePagination
        autoHeight
        getRowHeight={() => 'auto'}
        hideFooter
        sx={{
                height: '69vh',
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
      />
    </Box>
  );
};

export default UploadedImageList;
